import {IShopRating} from "@connox/typescript-library";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {FilterState} from "../ShopRatingSection";
import RatingStars from "../../lib/ratingStars/RatingStars";
import styles from "./ShopRatingComments.module.scss";

type ShopRatingCommentsProps = {
  comments: IShopRating[];
  filter: FilterState;
  onFilterComments: (comments: IShopRating[]) => void;
};

const ShopRatingComments: React.FC<ShopRatingCommentsProps> = (props) => {
  const {comments, filter, onFilterComments} = props;
  const [commentsState, setCommentsState] = useState(comments);
  const [more, setMore] = useState(5);
  const {t} = useTranslation();

  useEffect(() => {
    setCommentsState(() => {
      const {filterSet, sort} = filter;
      let filterdComments: IShopRating[];
      if (filterSet.size) {
        filterdComments = comments?.filter((comment) => {
          return filterSet.has(comment.rating);
        });
      } else {
        filterdComments = comments;
      }
      onFilterComments(filterdComments);
      switch (sort) {
        case "best":
          filterdComments.sort((a, b) => b.rating - a.rating);
          break;
        case "worst":
          filterdComments.sort((a, b) => a.rating - b.rating);
          break;
        case "newest":
          filterdComments.sort((a, b) => {
            const aDate = new Date(a.created).getTime();
            const bDate = new Date(b.created).getTime();

            return bDate - aDate;
          });
      }

      return filterdComments;
    });
  }, [filter, comments]);

  const commentComponents = commentsState.map((comment, index) => {
    const {content, created, customerName, itemName, ownerRemark, rating, subject, translated} = comment;
    if (index < more) {
      return (
        <div key={`comment${index}`} className={styles.commentWrapper}>
          <div>
            <RatingStars rating={rating * 2} size={"small"} />
            <div className={styles.title}>{subject}</div>
            <div className={styles.subtitle}>
              {new Intl.DateTimeFormat([]).format(new Date(created))},
              <meta itemProp="datePublished" content={created} />
              <span itemProp="author"> {customerName}</span>
              {", "}
              <span>
                <span>{itemName}</span>
              </span>
            </div>
          </div>
          <div className={styles.description}>
            {translated && <p className={styles.translationHint}>{t("Automatisch übersetzt aus dem Deutschen")}</p>}
            <p>{content}</p>
            {ownerRemark && (
              <>
                <br />
                <p>
                  <em>{t("Kommentar vom Connox-Team:")}</em>
                  <br />
                  {ownerRemark}
                </p>
              </>
            )}
          </div>
        </div>
      );
    } else {
      return null;
    }
  });

  return (
    <div className={styles.wrapper}>
      {commentComponents}
      <div className={styles.buttonWrapper}>
        {more < commentsState.length && (
          <button
            id={"loadMoreButton"}
            className={"button button-white button-large button-wide ga-bottom-filter-button"}
            onClick={() => {
              setMore(commentsState.length);
            }}
            type={"button"}
          >
            {t("Alle Bewertungen anzeigen")}
          </button>
        )}
      </div>
    </div>
  );
};

export default ShopRatingComments;
